import { get } from "./api";

export const getSubscriptionPlans = () => {
  return get("/api/v2/plans");
};
